import { CircleCheck, Film, IdCard, MapPin } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import { StudentInfo } from '~components/uas/StudentInfoForm';

import { Attachment } from '~types';

export interface Benefit {
  id: number;
  title: string;
  description: string;
  vistaCode?: any;
  restrictions?: any;
  icon: Attachment;
  quantity: number;
  frequency: string;
  available: number;
}

export interface Taker {
  id: number;
  name: string;
  lastName: string;
  phone: string;
  externalId: string;
  partnershipId: number;
  sid: string;
  updatedAt: string;
  createdAt: string;
  availableBenefits: Benefit[];
}

interface Props {
  data: Taker & StudentInfo;
}
const frequencies = {
  DAILY: 'Diario',
  WEEKLY: 'A la semana',
  MONTHLY: 'Al Mes',
  BIWEEKLY: 'A la quincena',
};
const Success: FC<Props> = ({ data }) => {
  return (
    <div className="flex flex-col items-center gap-6 px-6 md:px-12 py-8">
      <span className="rounded-full bg-success/5 p-4 text-success dark:bg-success/20">
        <CircleCheck />
      </span>
      <div>
        <h1 className="h3 font-bold text-center">¡Registro Exitoso!</h1>
        <p className="text-support">Bienvenido al programa de beneficios Citicinemas x UAS</p>
      </div>
      <div className="flex flex-col gap-2 w-full py-8">
        <p className="text-support uppercase font-bold text-xs">Información del registro</p>
        <p>
          <span className="text-support">Nombre:</span> {data.name} {data.lastName}
        </p>
        <p>
          <span className="text-support">Teléfono:</span> {data.phone}
        </p>
        <p>
          <span className="text-support">Escuela:</span> {data.school}
        </p>
        <p>
          <span className="text-support">Carrera:</span> {data.major}
        </p>
      </div>
      <div className="border bg-accent rounded-2xl w-full p-4 flex flex-col gap-4 items-center border-2 border-info/50">
        <span className="rounded-full bg-info/10 p-4 text-info">
          <IdCard />
        </span>
        <span className="text-support uppercase font-bold text-xs">Tu número de Matricula</span>
        <p className="text-center text-2xl font-bold text-info">
          {data.accountNumber || data.externalId.split('-').splice(1)}
        </p>
        <p className="text-support">Usa este número en los kioskos de Citicinemas</p>
      </div>
      <div className="rounded-lg border dark:border-neutral-600 bg-card p-4 w-full">
        <h3 className="mb-3 flex items-center gap-2 font-semibold text-foreground">
          <MapPin className="h-5 w-5 text-primary" />
          ¿Cómo usar tus beneficios?
        </h3>
        <ol className="space-y-2 text-sm text-support list-decimal list-inside">
          <li>Visita cualquier Citicinemas participante</li>
          <li>Busca el kiosko de autoservicio</li>
          <li>De la lista de afiliados Selecciona la Universidad Autonoma de Sinaloa</li>
          <li>
            Ingresa tu número de matrícula:{' '}
            <span className="font-semibold text-primary">{data?.accountNumber}</span>
          </li>
          <li>Ingresa el código que enviamos por SMS a tu celular.</li>
          <li>Selecciona e imprime tus cupones de descuento</li>
          <li>Presenta el cupón en taquilla o dulcería</li>
        </ol>
      </div>
      <div className="w-full">
        <p className="text-support uppercase font-bold text-xs mb-6">Tus Beneficios Disponibles</p>
        <ul className="flex flex-col border dark:border-neutral-600 rounded-lg divide-y dark:divide-neutral-600">
          {data.availableBenefits.map((benefit) => (
            <li key={benefit.id} className="flex items-center gap-3 p-4">
              <span className="w-12 h-12 rounded-full overflow-hidden">
                {benefit?.icon?.url && (
                  <Image src={benefit.icon.url} width={48} height={48} alt="" />
                )}
              </span>
              <div className="flex-1">
                <h4 className="font-semibold">{benefit.title}</h4>
                <p className="text-sm text-support mb-0">{benefit.description}</p>
              </div>
              <div className="flex flex-col items-center gap-1 text-center border-l pl-4 dark:border-l-neutral-600">
                <span>{benefit.quantity}</span>
                <span className="text-support uppercase font-bold text-xs">
                  {frequencies[benefit.frequency as keyof typeof frequencies]}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="grid grid-cols-2 gap-6 w-full">
        <Link className="btn btn-primary" href="/complejos">
          <MapPin size={16} /> <span>Ubicar Citicinemas</span>
        </Link>
        <Link className="btn dark:btn-dark" href="/">
          <Film size={16} /> <span>Ver Cartelera</span>
        </Link>
      </div>
    </div>
  );
};

export default Success;
